import { render } from "./New.vue?vue&type=template&id=15a21c5e"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__